/* file description */
import React, { FC, useEffect, useState } from 'react';
import { getAllRoleCache } from '@/common/asset-apis/assetModel';

import { RoleSelectRenderProps } from './type';
import memo from '../memo';

export const RoleSelectRender: FC<RoleSelectRenderProps> = ({
  FetchAPI,
  field,
  targerValue,
  setViewValue,
}) => {
  const [renderData, setRenderData] = useState<any>('');

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    getAllRoleCache(FetchAPI).then((res: any) => {
      res?.forEach((item: any) => {
        if (item.roleId === Number(targerValue)) {
          setRenderData(item.roleName);
        }
      })
    });
  }, [targerValue]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  return renderData;
};
export default memo(RoleSelectRender);
